import React from 'react';
import { connect } from 'react-redux'
import PermisosMasivos from './PermisosMasivos';

//Importación de actions.
import {
    getScreenData,
    resetState,
    setRedirectOk,
    deletePerfil,
    savePerfiles,
    addUsuario,
    deleteUsuario,
    addPermiso,
    deletePermiso,
    selectProducto,
    selectCategoria,
    selectPrograma,
    selectTodasFunciones,
    unselectTodasFunciones,
    checkFuncion,
    savePermisos,
    hidePopUp,
    showMoreProfiles,
    showLessProfiles,
    openModal
} from '../actions/PermisosMasivos';

const mapStateToProps = (state) => {
    return {
        data: state.permisosMasivos
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        getScreenData: (currentScope) => {
            dispatch(getScreenData(currentScope));
        },
        resetState: () => {
            dispatch(resetState());
        },
        setRedirectOk: () => {
            dispatch(setRedirectOk());
        },
        deletePerfil: (idPerfil) => {
            dispatch(deletePerfil(idPerfil));
        },
        savePerfiles: (perfilesSeleccionados) => {
            dispatch(savePerfiles(perfilesSeleccionados));
        },
        addUsuario: (login) => {
            dispatch(addUsuario(login));
        },
        deleteUsuario: (login) => {
            dispatch(deleteUsuario(login));
        },
        addPermiso: () => {
            dispatch(addPermiso());
        },
        deletePermiso: (idPermiso) => {
            dispatch(deletePermiso(idPermiso));
        },
        selectProducto: (idPermiso, id) => {
            dispatch(selectProducto(idPermiso, id));
        },
        selectCategoria: (idPermiso, id) => {
            dispatch(selectCategoria(idPermiso, id));
        },
        selectPrograma: (idPermiso, id) => {
            dispatch(selectPrograma(idPermiso, id));
        },
        selectTodasFunciones: (idPermiso) => {
            dispatch(selectTodasFunciones(idPermiso));
        },
        unselectTodasFunciones: (idPermiso) => {
            dispatch(unselectTodasFunciones(idPermiso));
        },
        checkFuncion: (idPermiso, idFuncion, checked) => {
            dispatch(checkFuncion(idPermiso, idFuncion, checked));
        },
        savePermisos: () => {
            dispatch(savePermisos());
        },
        hidePopUp: () => {
            dispatch(hidePopUp());
        },
        showMoreProfiles: () => {
            dispatch(showMoreProfiles());
        },
        showLessProfiles: () => {
            dispatch(showLessProfiles());
        },
        openModal:() =>{
            dispatch(openModal());
        }
    }
}

//Connect entre el componente y las props y actions.
const PermisosMasivosContainer = connect(mapStateToProps, mapDispatchToProps)(PermisosMasivos);

export default PermisosMasivosContainer;